export default "__VITE_ASSET__DO9ikl0F__"